import CryptoJS from 'crypto-js';

const key = CryptoJS.enc.Utf8.parse("ABCDEFABCDEF2020");  // 十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse('2020ABCDEFABCDER');   // 十六位十六进制数作为密钥偏移量

// 解密方法
export function Decrypt(word) {
    console.log(word)
    let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
    let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    let decrypt = CryptoJS.AES.decrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
}

// 加密方法
export function Encrypt(word) {
    let srcs = CryptoJS.enc.Utf8.parse(word);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.ciphertext.toString().toUpperCase();
}

//获取时间戳
export function setEncrypt() {
    var data = {
        timestamp: Date.parse(new Date()),
        appkey: 'FISSION_VIDEO',
        // apiName: 'ZEKumsH45xXUAymYaOgLQt9qL9f4sOJJbhn',
        nonce: randomPassword(16)
    }
    var str = `appId${data.appkey}timestamp${data.timestamp}nonce${data.nonce}`
    str = Encrypt(str)
    return str
}

export function randomPassword(size) {
    var seed = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
        'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'm', 'n', 'p', 'Q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
        '2', '3', '4', '5', '6', '7', '8', '9'
    );//数组
    let seedlength = seed.length;//数组长度
    var createPassword = '';
    for (var i = 0; i < size; i++) {
        var j = Math.floor(Math.random() * seedlength);
        createPassword += seed[j];
    }
    return createPassword;
}
//生成sign
export function signEncrypt() {
    const obj = {}
    obj.appId = "FISSION_VIDEO";
    obj.timestamp = new Date().getTime();
    obj.nonce = randomNum(20);
    let str = "";
    for (var j in obj) {
        str += j;
        str += obj[j];
    }
    const signStr = Encrypt(str);
    return signStr;
}

//生成随机数
export function randomNum(len) {
    var data = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
    var result = "";
    while (result.length < len) {
        var r = Math.floor(Math.random() * 62);
        if (result.indexOf(data[r]) < 0) {
            result += data[r];
        }
    }
    return result;
}




// WEBPACK FOOTER //
// ./src/assets/axios/authentication.js